// import jQuery from 'CommonScripts/jquery-1.10.2';

(function (window, document, $) {
    $(document).ready(function () {
        //mobile?
        var mobile = ($(window).width() < 768) ? true : false;
        //tables
        var tables = $(".article-content table");

        function scrollableTable() {
            if (!mobile) {
                $(tables).each(function () {
                    $(this).parent().removeClass("scroll-x");
                });
            } else {
                $(tables).each(function () {
                    $(this).parent().addClass("scroll-x");
                });
            }
        }
        scrollableTable();

        $(window).on('resize', function (e) {
            //is it still mobile?
            mobile = ($(window).width() < 768) ? true : false;
            scrollableTable();
        });

    });
})(window, document, jQuery);